import { DetailsHeader, Segments } from "components";
import { Route, Routes, Navigate } from "react-router";
import PacksReport from "../Pack/PacksReport";

import { RouteNames } from "enums";

const pages = [
  {
    to: "",
    label: "Packs",
  },
];

const PacksLicensingSegments = () => {
  return (
    <>
      <DetailsHeader title="Packs & Licensing" showReportLastUpdated />
      <Segments to={`/${RouteNames.reportingPacks}`}>
        {pages.map((page) => (
          <Segments.Segment key={page.label} {...page} />
        ))}
      </Segments>
      <div className="scrollable-content">
        <Routes>
          <Route path="" element={<PacksReport />} />
          <Route path="*" element={<Navigate to={`/${RouteNames.reportingPacks}`} replace />} />
        </Routes>
      </div>
    </>
  );
};

export default PacksLicensingSegments;
